<template>
  <div class="popular-direction">
    <div v-if="!isTwoLocationEditable" class="popular-direction-title">
      {{ title }}
    </div>
    <div class="popular-direction-wrapper">
      <nuxt-link
        v-for="item, index in directions"
        :key="index"
        :to="item.url"
        :rel="getLinkRel(item.url)"
        target="_blank"
        class="popular-direction-link flex flex-space-between"
      >
        <span class="popular-direction-link-text">{{ getLinkText(item.name) }}</span>
        <span class="popular-direction-link-cost">{{ item.price }} ₽</span>
      </nuxt-link>
    </div>
    <div v-if="directions === null">
      <popular-direction-skeleton
        :is-dispatch="isDispatch"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import { storeToRefs } from 'pinia';
import { useCityStore } from '~~/stores/city'
import { Location } from '~~/types/types'
import { CityPrice } from '~~/types/api'
import { usePopularDirectionsStore } from '~~/stores/popular-directions'
import PopularDirectionSkeleton from '~~/components/public/popular-directions/popular-direction-skeleton.vue'

const props = defineProps({
  location: {
    type: Object as PropType<Location>,
    default: () => ({})
  },
  isDispatch: {
    type: Boolean,
    default: false
  },
  separator: {
    type: String,
    default: '-'
  },
  isTwoLocationEditable: {
    type: Boolean,
    default: false
  }
})

const { updatePopularDirections } = usePopularDirectionsStore()
const { twoLocation, directionsFrom, directionsTo } = storeToRefs(usePopularDirectionsStore())
const { to } = storeToRefs(useCityStore())

const title = computed(() => {
  const name = props.location.name
  return props.isDispatch ? `Из города ${name}` : `В город ${name}`
})

const directions = computed(() => {
  return props.isDispatch ? directionsFrom.value : directionsTo.value
})

watch(
  () => props.location,
  () => {
    updateDirections()
  },
  { immediate: true }
)

function getLinkText(name: string): string {
  const locationName = props.location.name
  return props.isDispatch ? `${locationName} ${props.separator} ${name}` : `${name} ${props.separator} ${locationName}`
}

function getLinkRel(url: string): string {
  return url.indexOf('vozovoz.by') !== -1 || url.indexOf('minsk.') !== -1 ? 'nofollow' : ''
}

async function updateDirections() {
  const locationData = props.location.translit || ''
  const directionData =  props.isDispatch ? 'from' : 'to' 
  const destinationData = props.isTwoLocationEditable ? twoLocation.value.translit : to.value.translit
  await updatePopularDirections(locationData, directionData, destinationData)
}
    
await updateDirections()
</script>
